import type { SelectedOption } from "./types";

/**
 * Отпечаток набора опций — устойчивая строка, одинаковая у двух одинаковых
 * наборов независимо от порядка выбора.
 *
 * ПУСТОЙ набор даёт ПУСТУЮ строку. Это не мелочь: ключ позиции без опций
 * остаётся прежним, и состояние корзин, лежащих в persist, не едет. Тот же
 * приём бэк применил к хешу позиции, чтобы не мигрировать заказы в базе.
 */
export function optionsFingerprint(options: readonly SelectedOption[]): string {
  return options
    .map((o) => `${o.blockId}:${o.optionId}:${o.quantity}`)
    .sort()
    .join(";");
}

interface KeyedItem {
  productId: string;
  productSnapshot: { productId: string };
  options: readonly SelectedOption[];
}

/**
 * Ключ позиции корзины: товар плюс набор опций.
 *
 * Первая половина — ровно то выражение, которым дельта ключует позицию с
 * Ф7: в REST вариант товара это самостоятельный productId, и снимок знает
 * его точнее, чем поле позиции.
 */
export function itemKey(item: KeyedItem): string {
  const productId = item.productSnapshot.productId || item.productId;
  return `${productId}|${optionsFingerprint(item.options)}`;
}
